import styled from 'styled-components'

export default styled.div`
  background-color: ${props => props.theme.colors.grey15};
  width: 50px;
  height: 2px;
  margin: 0 10px;
  flex-shrink: 1;

  @media (max-width: 1000px) {
    margin: 0;
  }
 `
